import React, { useState, useEffect, useRef } from "react";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { makeStyles } from "@material-ui/core/styles";
import { Stack } from "@mui/material";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  }
}));

const FlowBuilderEndModal = ({
  open,
  onSave,
  data,
  onUpdate,
  close
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [sendFinishMessage, setSendFinishMessage] = useState(true);
  const [message, setMessage] = useState(
    "Obrigado por entrar em contato conosco! O atendimento foi finalizado. Se precisar de mais alguma coisa, não hesite em nos contatar novamente. 😊"
  );

  useEffect(() => {
    if (open === "edit") {
      const currentSend = data?.data?.sendFinishMessage !== false;
      const currentMessage =
        data?.data?.message ||
        data?.message ||
        "Obrigado por entrar em contato conosco! O atendimento foi finalizado. Se precisar de mais alguma coisa, não hesite em nos contatar novamente. 😊";
      
      setSendFinishMessage(currentSend);
      setMessage(currentMessage);
      setActiveModal(true);
    } else if (open === "create") {
      setSendFinishMessage(true);
      setMessage(
        "Obrigado por entrar em contato conosco! O atendimento foi finalizado. Se precisar de mais alguma coisa, não hesite em nos contatar novamente. 😊"
      );
      setActiveModal(true);
    }
    return () => {
      isMounted.current = false;
    };
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    if (open === "edit") {
      onUpdate({
        ...data,
        data: {
          ...data.data,
          sendFinishMessage,
          message: sendFinishMessage ? message : ""
        }
      });
    } else if (open === "create") {
      onSave({
        sendFinishMessage,
        message: sendFinishMessage ? message : ""
      });
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        scroll="paper"
      >
        <DialogTitle id="form-dialog-title">
          {open === "create"
            ? "Adicionar Finalizar Atendimento"
            : "Editar Finalizar Atendimento"}
        </DialogTitle>
        <Stack>
          <DialogContent dividers>
            <FormControlLabel
              control={
                <Switch
                  checked={sendFinishMessage}
                  onChange={e => setSendFinishMessage(e.target.checked)}
                  color="primary"
                />
              }
              label="Enviar mensagem de encerramento ao cliente?"
              style={{ marginBottom: "16px" }}
            />
            {sendFinishMessage && (
              <TextField
                label="Mensagem de Encerramento"
                name="message"
                value={message}
                onChange={e => setMessage(e.target.value)}
                autoFocus
                variant="outlined"
                margin="dense"
                multiline
                rows={4}
                fullWidth
                className={classes.textField}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              color="secondary"
              variant="outlined"
            >
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleSave}
            >
              {open === "create" ? "Adicionar" : "Editar"}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderEndModal;
